<template>
  <div :class="'col-lg-' + col">
    <div :class="'card ' + styleCard">
      <div class="card-header border-transparent" v-if="cardHead">
        <slot name="head" />
      </div>
      <div class="card-body " :class="customBody" :style="computedStyle">
        <slot name="body" />
      </div>
      <div class="card-footer text-right customFooter" v-if="cardFooter">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps<{
  col: number,
  styleCard: string,
  height: number | null,
  customBody: string,
  cardFooter: boolean,//[True] shows the card footer
  cardHead:boolean//[True] shows the card Head
}>();

const computedStyle = computed(() => {
  return props.height !== null ? `min-height: ${props.height}px;` : '';
});
</script>

<style>
.customFooter {
  background-color: #fff;
}

.custom-card-body {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center; /* Centra horizontalmente */
  padding: 1rem; /* Ajustar según sea necesario */
}
</style>
